import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React, { useState } from 'react';
import { Box, Grid, List, ListItem, TextField, Typography } from '@material-ui/core';
import Icon from '../../../../Icon';
import { makeStyles } from '@material-ui/core/styles';
import uuid from 'uuid';
import Dimension from '../components/Dimension';
import Window from '../../../../../modal/Window';
import cx from 'classnames';
import FormatButton from '../components/Format';
import { useDashboardState } from '../context/dashboardContext';
import { selectDimension } from '../context/selectors/dimensionSelector';
var useStyles = makeStyles(function (theme) {
  return {
    icon: {
      fontSize: 16
    },
    itemDelete: {
      display: 'none'
    },
    list: {
      margin: theme.spacing(0, -3)
    },
    listItem: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    listItemButton: {
      '&:hover': {
        '& $itemDelete': {
          display: 'block'
        }
      }
    }
  };
}, {
  name: 'ECInsertTableDialog'
});

var InsertTableDialog = function InsertTableDialog(_ref) {
  var onSubmit = _ref.onSubmit,
      onClose = _ref.onClose,
      _ref$widgetData = _ref.widgetData,
      widgetData = _ref$widgetData === void 0 ? null : _ref$widgetData;

  var _useState = useState(widgetData === null ? [{
    title: 'Column 1',
    value: null,
    id: uuid(),
    isCustom: false
  }] : widgetData.columns),
      _useState2 = _slicedToArray(_useState, 2),
      columns = _useState2[0],
      setColumns = _useState2[1];

  var classes = useStyles({});
  var dashboardState = useDashboardState();

  var getNextColumnTitle = function getNextColumnTitle() {
    var count = 1;

    while (columns.some(function (column) {
      return column.title === "Column ".concat(count);
    })) {
      count++;
    }

    return "Column ".concat(count);
  };

  var handleColumnTitleChange = function handleColumnTitleChange(index, value) {
    setColumns(columns.map(function (column, columnIndex) {
      return columnIndex === index ? _objectSpread({}, column, {
        title: value,
        isCustom: true
      }) : column;
    }));
  };

  var getColumnAlign = function getColumnAlign(value) {
    if (value.expression) return 'right';
    var dimension = selectDimension(dashboardState, value.source);

    switch (dimension.type) {
      case 'short':
      case 'double':
      case 'float':
      case 'int':
      case 'int64':
      case 'date':
        return 'right';

      default:
        break;
    }

    return '';
  };

  var handleColumnValueChange = function handleColumnValueChange(index, value) {
    setColumns(columns.map(function (column, columnIndex) {
      return columnIndex === index ? _objectSpread({}, column, {
        title: column.isCustom ? column.title : value.source,
        value: value,
        align: getColumnAlign(value)
      }) : column;
    }));
  };

  var handleFormatChange = function handleFormatChange(index, format) {
    setColumns(columns.map(function (column, columnIndex) {
      return columnIndex === index ? _objectSpread({}, column, {
        format: format
      }) : column;
    }));
  };

  return React.createElement(Window, {
    onClose: onClose,
    style: {
      width: 700
    },
    open: true,
    header: widgetData === null ? 'Insert Table' : 'Edit Table',
    submitLabel: "Insert",
    labelPlacement: "top",
    variant: "filled",
    hideCancelButton: true,
    disableRestoreFocus: true,
    disableBackdropClick: true,
    renderContent: function renderContent() {
      return React.createElement(Box, {
        p: 3
      }, React.createElement(Typography, null, "Columns"), React.createElement(List, {
        className: classes.list
      }, columns.map(function (column, columnIndex) {
        return React.createElement(ListItem, {
          key: column.id,
          button: true,
          disableRipple: true,
          className: classes.listItem,
          classes: {
            button: classes.listItemButton
          }
        }, React.createElement(Grid, {
          container: true,
          spacing: 3,
          alignItems: "center"
        }, React.createElement(Grid, {
          item: true,
          xs: 5
        }, React.createElement(TextField, {
          variant: "outlined",
          margin: "dense",
          value: column.title,
          onChange: function onChange(e) {
            return handleColumnTitleChange(columnIndex, e.target.value);
          },
          fullWidth: true,
          style: {
            margin: 0
          }
        })), React.createElement(Grid, {
          item: true,
          container: true,
          xs: true,
          alignItems: "center"
        }, React.createElement(Grid, {
          item: true,
          xs: true
        }, React.createElement(Dimension, {
          variant: "outlined",
          hasFunction: true,
          dimension: column.value,
          onChange: function onChange(dimension) {
            return handleColumnValueChange(columnIndex, dimension);
          }
        })), React.createElement(Grid, {
          item: true
        }, React.createElement(FormatButton, {
          disabled: !column.value,
          value: column.format,
          onChange: function onChange(value) {
            return handleFormatChange(columnIndex, value);
          }
        }))), React.createElement(Grid, {
          item: true,
          xs: 1
        }, React.createElement(Icon, {
          type: "delete",
          label: "Delete",
          buttonSize: "small",
          onClick: function onClick() {
            return setColumns(columns.filter(function (series) {
              return series.id !== column.id;
            }));
          },
          className: cx(classes.icon, classes.itemDelete)
        }))));
      })), React.createElement(Icon, {
        type: "add",
        label: "Add",
        buttonSize: "small",
        onClick: function onClick() {
          return setColumns([].concat(_toConsumableArray(columns), [{
            title: getNextColumnTitle(),
            value: null,
            id: uuid()
          }]));
        },
        className: classes.icon
      }));
    },
    footerButtons: {
      submit: {
        onClick: function onClick() {
          return onSubmit({
            id: widgetData === null ? uuid() : widgetData.id,
            columns: columns
          });
        },
        disabled: columns.length === 0 || columns.some(function (column) {
          return !column.title || column.value === null;
        }),
        children: 'OK'
      },
      cancel: {}
    }
  });
};

export default InsertTableDialog;